import { useState } from "react";

import { AddProxy, ProxySelectFormField } from "common/components/Proxy";
import useWorkspaceProxies from "common/datahooks/useWorkspaceProxies";
import type { WorkspaceAccount } from "common/types";

import useAccountProxy from "../../datahooks/useAccountProxy";
import useAccountProxyMutations from "../../datahooks/useAccountProxyMutations";

export default function AccountProxy({
  account,
}: {
  account: WorkspaceAccount;
}) {
  const { isLoadingAccountProxy, accountProxy } = useAccountProxy(account);
  const { setAccountProxy } = useAccountProxyMutations();
  const { workspaceProxies } = useWorkspaceProxies();
  const [isAddProxyOpen, setIsAddProxyOpen] = useState(false);

  const proxy = workspaceProxies?.find(({ id }) => id === accountProxy);

  let proxyError: string;
  if (proxy && !proxy.valid) {
    proxyError = "Invalid proxy, please switch, or re-verify";
  }

  return (
    <>
      <div className="flex flex-col px-2">
        <ProxySelectFormField
          selectedProxy={accountProxy}
          setSelectedProxy={(newProxy) =>
            setAccountProxy({ accountId: account.id, proxy: newProxy })
          }
          onAddProxy={() => setIsAddProxyOpen(true)}
          error={proxyError}
          isLoading={isLoadingAccountProxy}
        />
      </div>
      <AddProxy
        isOpen={isAddProxyOpen}
        setIsOpen={setIsAddProxyOpen}
        onAdded={(newProxy) =>
          setAccountProxy({ accountId: account.id, proxy: newProxy })
        }
      />
    </>
  );
}
